/***********************************************************************************************************************
 *                                                                                                                     *
 * V1.0                                                                                                                *
 *                                                                                                                     *
 * User: margalitb                                                                                                     *
 * Date: 29/07/13                                                                                                      *
 * Visual PDF:                                                                                                         *
 *      https://drive.google.com/a/liveperson.com/?tab=mo#folders/0BzCszeQVU73yUU8wdVdsMW41Qzg                         *
 *                                                                                                                     *
 * ********************************************************************************************************************/

define(/** @lends Dropdown */ function (require) {

    "use strict";

    /////////////////////////////////////////////////////////////////////////////
    //                              Dependencies                               //
    /////////////////////////////////////////////////////////////////////////////
    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var Logger = require("logger");

    var template =  require("ui/radio-button-list/templates/radioButtonList.tmpl");
    var RadioButtonItemView =  require("ui/radio-button-list/js/views/RadioButtonItemView");
    var RadioButtonCollection =  require("ui/radio-button-list/js/collections/RadioButtonCollection");
    var Bubble = require("ui/bubble/Bubble");
    var Tooltip = require('ui/tooltip/Tooltip');

    /**
     * Creates a new instance of the Radio Button class.
     *
     * @example
     * var RadioButton = require('ui/radio-button/RadioButton');
     * var sex = new RadioButton({
     *     el: this.ui.sexPlaceholder,
     *     name: 'sex',
     *     items: [
     *     {key: 'maleKey', label: 'Male',tooltip:'tooltip'},
      *    {
      *      key: 'femaleKey',
      *      label: 'Female',
      *      tooltip:'tooltip',
      *      'embeddedView': embeddedViewInstance // if you want setFocus,setEnabled handled by the radioButtonComponent have the functions implemented on the embedded view interface
      *   }
           ],
     *     defaultSelection: 'maleKey',
     *     allowHtml: false // allow html rendering within labels
     * });
     *
     * sex.render();
     *
     * @constructor RadioButton
     *
     * @param {Dropdown.Options} options.
     *
     * @requires jquery
     * @requires backbone
     * @requires marionette
     * @requires underscore
     *
     * @augments Marionette.ItemView
     *
     * @classdesc A radio-button field that is used as a replacement for traditional HTML radio-button.
     */

    var RadioButtonList = Marionette.CompositeView.extend({
        template: template,
        withUIComponents: true,
        errorMsg:null,
        itemView: RadioButtonItemView,
        itemViewContainer:".radio-button-wrapper",
        itemEvents: {
            "itemClicked" : "_radioClicked"
        },
        //marrionette functions
        initialize: function (options) {
            this.logger = Logger.getLogger("RadioButtonList");
            this.logger.debug("Initializing RadioButtonList", "RadioButtonList:initialize");
            this.items = options.items;
            this.allowHtml = options.allowHtml || false;
            this.permutation = options.permutation || RadioButtonList.PERMUTATION.A;
            this.selectionKey = this._calcSelectionKey(options.defaultSelection);
            this.errorPosition = options.errorPosition || RadioButtonList.ERROR_POSITION.BOTTOM;
            this.collection = new RadioButtonCollection(this.items);
        },
        itemViewOptions: function(model,index){
            return {
                allowHtml: this.allowHtml
            };
        },

        customTemplateHelpers : function () {
            return {
                permutationClass: this.permutation
            };
        },

        onRender: function(){
            this.setSelection(this.selectionKey);
        },
        onClose: function(){
            this.logger.debug("closing RadioButtonList", "RadioButtonList:onClose");
        },
        //public functions

        setItems: function(items,options){
            options = options || {};
            this.items = items;
            this.selectionKey = this._calcSelectionKey(options.defaultSelection);
            this.collection.reset(this.items);
        },

        /**
         * Remove the radio selection from the old item and Set the radio selection to new item.
         *
         * @param key of the radio button key to be selected.
         */
        setSelection: function(key, options){
            options = options || {};
            options.silent = _.has(options, "silent") ? options.silent : true;
            this.selectionKey = key;
            this.collection.each(function(model){
                model.setSelected(this.selectionKey === model.id);
            },this);

            if(!options.silent){
                this.trigger('change', key);
            }
        },

        /**
         * Enable/disable all items
         */
        setEnableAll: function(enable){

            this.collection.each(function(model){
                model.setEnabled(enable);
            },this);
        },

        getSelectedKey: function(){
            return this.selectionKey;
        },

        //private functions
        _calcSelectionKey: function(defaultSelection){
            return _.isUndefined(defaultSelection) || _.where(this.items, {key: defaultSelection}).length === 0  ? this.items[0].key  : defaultSelection;
        },
        _radioClicked: function(eventName,view){
            var key =  view.model.id;
            var isEnabled = view.model.getEnabled();

            if (isEnabled && key !== this.selectionKey) {
                this.setSelection(view.model.id,{silent: false});
            }
        }
    });

    RadioButtonList.ERROR_POSITION = Bubble.POSITION;
    RadioButtonList.TOOLTIP_POSITION = Tooltip.POSITION;
    RadioButtonList.TOOLTIP_ALIGN = Tooltip.ALIGN;
    RadioButtonList.BUBBLE_POSITION = Bubble.POSITION;
    RadioButtonList.BUBBLE_ALIGN = Bubble.ALIGN;

    /**
     * Radio Button permutation.
     */
    RadioButtonList.PERMUTATION = {
        A: "perm-A",
        B: "perm-B",
        C: "perm-C",
        D: "perm-D"
    };

    // return the input-field component.
    return RadioButtonList;
});


